var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForkLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520-120v-160q-18-64-63.5-94.5T357-405q-11 0-22 1.5t-22 3.5l63 64-56 56-160-160 160-160 56 56-63 64q9-2 19-3t21-1q44 0 88 13.5t79 44.5v-261l-64 64-56-57 160-160 160 160-56 56-64-63v567h-80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForkLeft);
export default __webpack_public_path__ + "static/media/fork-left.fa71dd27c9d0aa33acaddee361587ee2.svg";
export { ForwardRef as ReactComponent };